function setCookie(code) {
    c1name = 'state_code';
    c1value = code;
    document.cookie = c1name + '=' + c1value;
}
  
function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
}
  
function displayNormal(){
    document.getElementById("notice").style.display = 'none';
  	document.getElementById("atcForm").style.display = 'block';
    document.getElementById("variant-select").style.display = 'block';
}

function format(code){
    var notice = document.getElementById('notice');
    var content = '<p>This product can not be shipped to California or Iowa.';
    content += '<br><a style="text-decoration: underline; color: #273746;" href="https://boroux.com/collections/california-water-filter-systems">Browse products we can ship to your state</a></p>'
    notice.innerHTML = content;
    document.getElementById("notice").style.display = 'block';
}

function getState(ip){
    var url = "https://api.boroux.com/ip-location/get-state/" + ip;
 	xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function() {
        if (this.readyState == 4 && this.status == 200) {
          try {
          	var res = JSON.parse(xhttp.responseText);
            if (!res) displayNormal();
            var form = document.getElementById("atcForm");
            setCookie(res.state_code);
            if(res.state_code == "CA" || res.state_code == "IA"){
                format(res.state_code);
            }else{
                form.style.display = 'block';
            }
          } catch (err) {
          	displayNormal();
          }
        }
    };
    xhttp.open("GET", url, true);
    xhttp.send();
}

function getIp(){
  var xhttp = new XMLHttpRequest();
  xhttp.onreadystatechange = function() {
      if (this.readyState == 4 && this.status == 200) {
        getState(xhttp.responseText);
      }
  };
  xhttp.open("GET", "https://api.ipify.org", true);
  xhttp.send();
}

function checkCookie(){
  	displayNormal();
    return
    try{
        var code = getCookie('state_code');
        if(code != null && code != 'undefined' && code != ''){
            if(code == 'CA' || code == 'IA'){
                format(code);
            }else{
            	displayNormal();
            }
        }else{
            getIp();
        }
    }catch(err){
     	displayNormal();
    }
}

window.onload += checkCookie();
